import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, Modal } from '@lamimed/pantheon';
import { FileDown } from 'lucide-react';
import Image from 'next/image';

import { sizeToText } from 'utils/constants/uploadRules';

import { UploadedFile } from 'templates/Schedule/shared/hooks/useAppointmentFiles';

import { FileBox } from 'components/FileBox';

import * as S from './styles';

export type ViewFile = Partial<UploadedFile> & { position?: number };

interface ViewFileModalProps {
  file?: ViewFile;
  maxFiles?: number;
  isOpen: boolean;
  handleCloseModal: () => void;
}

export const ViewFileModal = ({
  file,
  maxFiles,
  isOpen,
  handleCloseModal,
}: ViewFileModalProps) => {
  const [loading, setLoading] = useState(true);

  const { t } = useTranslation();

  useEffect(() => {
    if (isOpen) {
      setLoading(true);
    }
  }, [isOpen]);

  return (
    <S.Wrapper>
      <Modal
        open={isOpen}
        onClose={handleCloseModal}
        dismissible
        showCloseButton={false}
        size="large"
      >
        <S.ScrollWrapper>
          <S.ImageWrapper loading={loading}>
            {file && file.thumbnail && (
              <Image
                src={file.thumbnail}
                alt={`${file.name}-thumb`}
                fill
                onLoadingComplete={() => setLoading(false)}
              />
            )}
          </S.ImageWrapper>
        </S.ScrollWrapper>

        <S.FileBoxContainer>
          {file && (
            <FileBox
              id={file.id}
              fileTitle={file.name}
              format={file.format}
              filePosition={file.position}
              variant="modalView"
              maxFiles={maxFiles}
              fileSize={file.bytes ? sizeToText(file.bytes) : undefined}
              handleView={handleCloseModal}
            />
          )}
        </S.FileBoxContainer>

        <S.DownloadButtonWrapper>
          <S.DownloadDocumentButton
            variant="light"
            expanded
            onClick={() => window.open(file?.url, '_blank')}
          >
            <FileDown color={colors.dark} />

            {t('page--patient-area.downloadDocument')}
          </S.DownloadDocumentButton>
        </S.DownloadButtonWrapper>
      </Modal>
    </S.Wrapper>
  );
};
